/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SVGIcons } from "cms/icons/svg-icons";

const AddLineWithIcon = (props) => {
    
    const {
        addNewItem,
        index,
    } = props;
    
    const addItem = () => {
        addNewItem(index);
    };
    
    return (
        <div className='add-icon-line' onClick={addItem}>
            <SVGIcons.common.Add/>
        </div>
    );
};

export { AddLineWithIcon };
